const key = "MTgxNzdfMTY1MzY4MzkzNV9kYjYzMWU5N2RiYTZmMzFmOWE4NzQ5ZWVhNDAxMTk5MDkxZjczYmUz";

export default key;